import script from "./SellerDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SellerDetail.vue?vue&type=style&index=0&id=72d9399a&lang=scss&scoped=true"
import "./SellerDetail.vue?vue&type=style&index=1&id=72d9399a&lang=scss"
import "./SellerDetail.vue?vue&type=style&index=2&id=72d9399a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d9399a"]])

export default __exports__